import { render, staticRenderFns } from "./upnext.vue?vue&type=template&id=1d0f9334&scoped=true"
import script from "./upnext.vue?vue&type=script&lang=js"
export * from "./upnext.vue?vue&type=script&lang=js"
import style0 from "./upnext.vue?vue&type=style&index=0&id=1d0f9334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0f9334",
  null
  
)

export default component.exports